import trackConversion from 'utils/trackConversion';

import userService from 'resources/user/user.service';
import companyService from 'resources/company/company.service';
import listedkitService from 'resources/listedkit/listedkit.service';
import * as authService from 'resources/auth/auth.service';

import { createDefaultKitTemplates } from 'resources/listedkit/workflows';
import createDefaultEmailTemplates from 'resources/template/workflows/createDefaultEmailTemplates';
import { createAdvancedFields } from 'resources/advanced-fields-to-company/workflows/createAdvancedFields';

const createAccount = async ({ authId, email }) => {
  const company = await companyService.createCompany();

  // create advanced fields
  await createAdvancedFields({ companyId: company.id });

  // create email templates
  const defaultEmailTemplates = await createDefaultEmailTemplates({ companyId: company.id });

  // create default listed kits
  const defaultKitTemplates = listedkitService.getDefaultKitTemplates(defaultEmailTemplates);
  await createDefaultKitTemplates(defaultKitTemplates, company.id);

  // create user
  const userResult = await userService.createRegisteredUser({
    authId,
    companyId: company.id,
    email: email.toLowerCase(),
  });

  return userResult;
};

const signup = async ({ email, password }) => {
  const signupResult = await authService.signUp({
    email: email.toLowerCase(),
    password,
  });

  if (signupResult.isBadRequest) {
    return null;
  }

  const createdUser = await createAccount({
    authId: signupResult.user.id,
    email,
  });

  try {
    trackConversion(createdUser.email);
  } catch (error) {
    // Do not block the user from signing up
    console.error('Error tracking conversion during sign up: ', error);
  }

  return createdUser;
};

const signupWithGoogle = async (auth) => {
  const user = await createAccount({
    authId: auth.id,
    email: auth.email,
  });

  await userService.updateUser({
    id: user.id,
    app_state: {
      ...user.app_state,
      is_email_verified: true,
    },
  });

  try {
    trackConversion(auth.email);
  } catch (error) {
    // Do not block the user from signing up
    console.error('Error tracking conversion during sign up with Google: ', error);
  }
};

export {
  signup,
  signupWithGoogle,
};
